<template>
  <div>
    <transition-group
      v-if="videos && videos.length > 0"
      name="fade"
      tag="div"
      class="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <div
        v-for="video in videos"
        :key="video.id"
        class="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer flex flex-col"
        @click="select_video(video.id)"
      >
        <!-- Thumbnail -->
        <div class="relative overflow-hidden" style="aspect-ratio: 16/9;">
          <img
            v-if="video.picture"
            :src="video.picture.medium"
            :alt="video.title"
            class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div
            v-else
            class="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-14 h-14 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M15 10l4.553-2.276A1 1 0 0121 8.723v6.554a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
            </svg>
          </div>

          <!-- Play overlay -->
          <div class="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div class="bg-white/90 rounded-full p-4 shadow-lg transform scale-90 group-hover:scale-100 transition-transform duration-300">
              <svg class="w-8 h-8 text-gray-900 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-1 p-4 gap-2">
          <h3 class="font-semibold text-gray-900 text-base leading-snug line-clamp-2">{{ video.title }}</h3>
          <p v-if="video.teaser" class="text-gray-500 text-sm leading-relaxed line-clamp-2 flex-1">{{ video.teaser }}</p>

          <!-- Tags -->
          <div v-if="video.tags && video.tags.length" class="flex flex-wrap gap-1 mt-1" @click.stop>
            <span
              v-for="tag in video.tags"
              :key="tag.id"
              @click="toggle_tag(tag.id)"
              class="px-3 py-1 rounded-full text-sm font-medium transition-colors duration-200"
              :class="active_tag(tag.id)
                ? 'bg-gray-900 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
            >{{ tag.title }}</span>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useVideoStore } from '../stores'

export default {
  computed: {
    ...mapState(useVideoStore, ['active_tag', 'selected_videos']),
    videos() { return this.selected_videos }
  },
  methods: {
    ...mapActions(useVideoStore, ['select_video', 'toggle_tag'])
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
